import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';import { apiService } from '../../constants/ApiService';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';

const AllStages = () => {
    const navigate = useNavigate();
    const authData = useSelector(state => state.authState);
    const [userDetail, setUserDetail] = useState(authData.user);
    const [stagesList, setStagesList] = useState([]); 
    const handleStageClick = (stage) => {
        navigate("/all-levels",{state:{stage:stage}})        
    };

    const getStagesList = async () => {

        try {
            const response = await apiService.get(`/api/Stage_Details_Master/GetStage_Details_Master`)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            console.log(response)

            if (response.status === true) {
                setStagesList(response.data);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    useEffect(() => {

        if (authData.login) {
            getStagesList()
        }
    }, [])

    return(
        <>
            <section className="user-dashboard-section section-b-space">
                    <div className="container-fluid-lg">
                        <div className="row">
                            <div className="col-xxl-12 col-lg-12">  
                            <div className="dashboard-card">
                            <div className="title">
                                            <h2>All Grades</h2>
                                            <span className="title-leaf">
                                                <svg className="icon-width bg-gray">
                                                    <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                </svg>
                                            </span>
                                        </div>
                                        {stagesList.map((item) => {
                                            return (
                                                <>
                                                    <div onClick={() => { handleStageClick(item.id) }} className="seller-grid-box seller-grid-box-1 shadow-lg mb-2">
                                                        <div className="grid-image mb-0">
                                                            <div className="contain-name">
                                                                <div>

                                                                    <h3 className="mr-3">{item.stage_no}. {item.stage_display_name}
                                                                    {/* <label className="product-label float-end"> Total 15 Levels</label> */}
                                                                    </h3>
                                                                    <div className="since-number">
                                                                        <h5>{item.stage_short_desc}</h5>
                                                                    </div>
                                                                    <div className="since-number">
                                                                        <h6>{item.stage_desc}</h6>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="image float-end">
                                                                <img
                                                                    src="../assets/images/vendor-page/logo/6.png"
                                                                    className="img-fluid"
                                                                    alt=""
                                                                />
                                                            </div>

                                                            <div>
                                                            
                                                            <i className="fa-solid fa-angle-right nav-link text-success"></i>
                                                              
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </>)
                                        })}
                            </div>
                            </div> 
                        </div>
                    </div>
            </section>
        </>)
}

export default AllStages;